export interface Contact {
  id: string
  firstname: string
  lastname: string
  email: string
  createdate: string
}

interface HubSpotSearchResponse {
  results: Array<{
    id: string
    properties: {
      firstname: string | null
      lastname: string | null
      email: string | null
      createdate: string | null
    }
  }>
}

async function hubspotFetch<T>(portalId: string, path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`/api/hubspot/${portalId}${path}`, options)
  if (!res.ok) {
    throw new Error(`HubSpot API error: ${res.status} ${res.statusText}`)
  }
  return res.json() as Promise<T>
}

function startOfWeekMs(): number {
  const now = new Date()
  const day = now.getUTCDay()
  const diff = day === 0 ? 6 : day - 1
  const monday = new Date(now)
  monday.setUTCDate(now.getUTCDate() - diff)
  monday.setUTCHours(0, 0, 0, 0)
  return monday.getTime()
}

export interface AccountDetails {
  portalId: number
  hub_domain: string
  timeZone: string
}

export async function getAccountDetails(portalId: string): Promise<AccountDetails> {
  return hubspotFetch<AccountDetails>(portalId, '/account-info/v3/details')
}

export async function listContactsThisWeek(portalId: string): Promise<Contact[]> {
  const since = startOfWeekMs()
  const body = {
    filterGroups: [
      {
        filters: [
          {
            propertyName: 'createdate',
            operator: 'GTE',
            value: String(since),
          },
        ],
      },
    ],
    properties: ['firstname', 'lastname', 'email', 'createdate'],
    sorts: [{ propertyName: 'createdate', direction: 'DESCENDING' }],
    limit: 100,
  }

  const data = await hubspotFetch<HubSpotSearchResponse>(
    portalId,
    '/crm/v3/objects/contacts/search',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }
  )

  return data.results.map((r) => ({
    id: r.id,
    firstname: r.properties.firstname ?? '',
    lastname: r.properties.lastname ?? '',
    email: r.properties.email ?? '',
    createdate: r.properties.createdate ?? '',
  }))
}
